var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "divBox" },
    [
      _c(
        "el-card",
        { staticClass: "box-card" },
        [
          _c(
            "el-tabs",
            {
              on: { "tab-click": _vm.handleTabClick },
              model: {
                value: _vm.activeTab,
                callback: function ($$v) {
                  _vm.activeTab = $$v
                },
                expression: "activeTab",
              },
            },
            [
              _c(
                "el-tab-pane",
                { attrs: { label: "开心果流水", name: "happyFruit" } },
                [
                  _c(
                    "div",
                    { staticClass: "search-bar" },
                    [
                      _c(
                        "el-form",
                        { attrs: { inline: "", size: "small" } },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { label: "用户UID" } },
                            [
                              _c("el-input", {
                                staticStyle: { width: "150px" },
                                attrs: {
                                  placeholder: "用户UID",
                                  clearable: "",
                                },
                                model: {
                                  value: _vm.searchForm.uid,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.searchForm, "uid", $$v)
                                  },
                                  expression: "searchForm.uid",
                                },
                              }),
                            ],
                            1
                          ),
                          _c(
                            "el-form-item",
                            { attrs: { label: "手机号" } },
                            [
                              _c("el-input", {
                                staticStyle: { width: "160px" },
                                attrs: { placeholder: "手机号", clearable: "" },
                                model: {
                                  value: _vm.searchForm.phone,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.searchForm, "phone", $$v)
                                  },
                                  expression: "searchForm.phone",
                                },
                              }),
                            ],
                            1
                          ),
                          _vm.activeTab !== "zoneConsume"
                            ? _c(
                                "el-form-item",
                                { attrs: { label: "类型" } },
                                [
                                  _c(
                                    "el-select",
                                    {
                                      staticStyle: { width: "150px" },
                                      attrs: {
                                        placeholder: "全部",
                                        clearable: "",
                                      },
                                      model: {
                                        value: _vm.searchForm.type,
                                        callback: function ($$v) {
                                          _vm.$set(_vm.searchForm, "type", $$v)
                                        },
                                        expression: "searchForm.type",
                                      },
                                    },
                                    _vm._l(_vm.typeOptions, function (item) {
                                      return _c("el-option", {
                                        key: item.value,
                                        attrs: {
                                          label: item.label,
                                          value: item.value,
                                        },
                                      })
                                    }),
                                    1
                                  ),
                                ],
                                1
                              )
                            : _vm._e(),
                          _c(
                            "el-form-item",
                            [
                              _c(
                                "el-button",
                                {
                                  attrs: { type: "primary" },
                                  on: {
                                    click: function ($event) {
                                      return _vm.getList(1)
                                    },
                                  },
                                },
                                [_vm._v("搜索")]
                              ),
                              _c(
                                "el-button",
                                { on: { click: _vm.handleReset } },
                                [_vm._v("重置")]
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ]
              ),
              _c(
                "el-tab-pane",
                { attrs: { label: "佣金流水", name: "commission" } },
                [
                  _c(
                    "div",
                    { staticClass: "search-bar" },
                    [
                      _c(
                        "el-form",
                        { attrs: { inline: "", size: "small" } },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { label: "用户UID" } },
                            [
                              _c("el-input", {
                                staticStyle: { width: "150px" },
                                attrs: {
                                  placeholder: "用户UID",
                                  clearable: "",
                                },
                                model: {
                                  value: _vm.searchForm.uid,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.searchForm, "uid", $$v)
                                  },
                                  expression: "searchForm.uid",
                                },
                              }),
                            ],
                            1
                          ),
                          _c(
                            "el-form-item",
                            { attrs: { label: "手机号" } },
                            [
                              _c("el-input", {
                                staticStyle: { width: "160px" },
                                attrs: { placeholder: "手机号", clearable: "" },
                                model: {
                                  value: _vm.searchForm.phone,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.searchForm, "phone", $$v)
                                  },
                                  expression: "searchForm.phone",
                                },
                              }),
                            ],
                            1
                          ),
                          _c(
                            "el-form-item",
                            { attrs: { label: "类型" } },
                            [
                              _c(
                                "el-select",
                                {
                                  staticStyle: { width: "150px" },
                                  attrs: { placeholder: "全部", clearable: "" },
                                  model: {
                                    value: _vm.searchForm.type,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.searchForm, "type", $$v)
                                    },
                                    expression: "searchForm.type",
                                  },
                                },
                                [
                                  _c("el-option", {
                                    attrs: {
                                      label: "直推奖释放转入",
                                      value: 1,
                                    },
                                  }),
                                  _c("el-option", {
                                    attrs: { label: "复购扣减", value: 2 },
                                  }),
                                  _c("el-option", {
                                    attrs: { label: "手动调整", value: 3 },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _c(
                            "el-form-item",
                            [
                              _c(
                                "el-button",
                                {
                                  attrs: { type: "primary" },
                                  on: {
                                    click: function ($event) {
                                      return _vm.getList(1)
                                    },
                                  },
                                },
                                [_vm._v("搜索")]
                              ),
                              _c(
                                "el-button",
                                { on: { click: _vm.handleReset } },
                                [_vm._v("重置")]
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ]
              ),
              _c(
                "el-tab-pane",
                { attrs: { label: "余额流水", name: "balance" } },
                [
                  _c(
                    "div",
                    { staticClass: "search-bar" },
                    [
                      _c(
                        "el-form",
                        { attrs: { inline: "", size: "small" } },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { label: "用户UID" } },
                            [
                              _c("el-input", {
                                staticStyle: { width: "150px" },
                                attrs: {
                                  placeholder: "用户UID",
                                  clearable: "",
                                },
                                model: {
                                  value: _vm.searchForm.uid,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.searchForm, "uid", $$v)
                                  },
                                  expression: "searchForm.uid",
                                },
                              }),
                            ],
                            1
                          ),
                          _c(
                            "el-form-item",
                            { attrs: { label: "手机号" } },
                            [
                              _c("el-input", {
                                staticStyle: { width: "160px" },
                                attrs: { placeholder: "手机号", clearable: "" },
                                model: {
                                  value: _vm.searchForm.phone,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.searchForm, "phone", $$v)
                                  },
                                  expression: "searchForm.phone",
                                },
                              }),
                            ],
                            1
                          ),
                          _c(
                            "el-form-item",
                            { attrs: { label: "类型" } },
                            [
                              _c(
                                "el-select",
                                {
                                  staticStyle: { width: "150px" },
                                  attrs: { placeholder: "全部", clearable: "" },
                                  model: {
                                    value: _vm.searchForm.type,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.searchForm, "type", $$v)
                                    },
                                    expression: "searchForm.type",
                                  },
                                },
                                [
                                  _c("el-option", {
                                    attrs: {
                                      label: "直推奖释放转入",
                                      value: 1,
                                    },
                                  }),
                                  _c("el-option", {
                                    attrs: { label: "复购扣减", value: 2 },
                                  }),
                                  _c("el-option", {
                                    attrs: { label: "提现扣减", value: 3 },
                                  }),
                                  _c("el-option", {
                                    attrs: { label: "手动调整", value: 4 },
                                  }),
                                  _c("el-option", {
                                    attrs: { label: "提现退回", value: 5 },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _c(
                            "el-form-item",
                            [
                              _c(
                                "el-button",
                                {
                                  attrs: { type: "primary" },
                                  on: {
                                    click: function ($event) {
                                      return _vm.getList(1)
                                    },
                                  },
                                },
                                [_vm._v("搜索")]
                              ),
                              _c(
                                "el-button",
                                { on: { click: _vm.handleReset } },
                                [_vm._v("重置")]
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ]
              ),
              _c(
                "el-tab-pane",
                { attrs: { label: "专区消费记录", name: "zoneConsume" } },
                [
                  _c(
                    "div",
                    { staticClass: "search-bar" },
                    [
                      _c(
                        "el-form",
                        { attrs: { inline: "", size: "small" } },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { label: "用户UID" } },
                            [
                              _c("el-input", {
                                staticStyle: { width: "150px" },
                                attrs: {
                                  placeholder: "用户UID",
                                  clearable: "",
                                },
                                model: {
                                  value: _vm.searchForm.uid,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.searchForm, "uid", $$v)
                                  },
                                  expression: "searchForm.uid",
                                },
                              }),
                            ],
                            1
                          ),
                          _c(
                            "el-form-item",
                            { attrs: { label: "手机号" } },
                            [
                              _c("el-input", {
                                staticStyle: { width: "160px" },
                                attrs: { placeholder: "手机号", clearable: "" },
                                model: {
                                  value: _vm.searchForm.phone,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.searchForm, "phone", $$v)
                                  },
                                  expression: "searchForm.phone",
                                },
                              }),
                            ],
                            1
                          ),
                          _c(
                            "el-form-item",
                            { attrs: { label: "专区类型" } },
                            [
                              _c(
                                "el-select",
                                {
                                  staticStyle: { width: "150px" },
                                  attrs: { placeholder: "全部", clearable: "" },
                                  model: {
                                    value: _vm.searchForm.zoneType,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.searchForm, "zoneType", $$v)
                                    },
                                    expression: "searchForm.zoneType",
                                  },
                                },
                                [
                                  _c("el-option", {
                                    attrs: { label: "企业活动专区", value: 1 },
                                  }),
                                  _c("el-option", {
                                    attrs: { label: "商家赋能专区", value: 2 },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _c(
                            "el-form-item",
                            [
                              _c(
                                "el-button",
                                {
                                  attrs: { type: "primary" },
                                  on: {
                                    click: function ($event) {
                                      return _vm.getList(1)
                                    },
                                  },
                                },
                                [_vm._v("搜索")]
                              ),
                              _c(
                                "el-button",
                                { on: { click: _vm.handleReset } },
                                [_vm._v("重置")]
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ]
              ),
            ],
            1
          ),
          _c(
            "el-table",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.listLoading,
                  expression: "listLoading",
                },
              ],
              staticStyle: { width: "100%" },
              attrs: {
                data: _vm.tableData.data,
                size: "mini",
                "highlight-current-row": "",
              },
            },
            [
              _c("el-table-column", {
                attrs: {
                  type: "index",
                  label: "序号",
                  width: "60",
                  index: (_vm.searchForm.page - 1) * _vm.searchForm.limit + 1,
                },
              }),
              _vm.activeTab === "happyFruit"
                ? [
                    _c("el-table-column", {
                      key: "hf-uid",
                      attrs: { prop: "uid", label: "用户UID", width: "100" },
                    }),
                    _c("el-table-column", {
                      key: "hf-nickname",
                      attrs: {
                        prop: "nickname",
                        label: "用户昵称",
                        width: "120",
                      },
                    }),
                    _c("el-table-column", {
                      key: "hf-phone",
                      attrs: { prop: "phone", label: "手机号", width: "120" },
                    }),
                    _c("el-table-column", {
                      key: "hf-type",
                      attrs: { label: "类型", width: "120" },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "default",
                            fn: function (scope) {
                              return [
                                scope.row.type === 1
                                  ? _c("span", [_vm._v("消费赠送")])
                                  : scope.row.type === 2
                                  ? _c("span", [_vm._v("直推奖释放扣减")])
                                  : scope.row.type === 3
                                  ? _c("span", [_vm._v("手动调整")])
                                  : _vm._e(),
                              ]
                            },
                          },
                        ],
                        null,
                        false,
                        3051171575
                      ),
                    }),
                    _c("el-table-column", {
                      key: "hf-zone",
                      attrs: { label: "专区", width: "90" },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "default",
                            fn: function (scope) {
                              return [
                                scope.row.zoneType === 1
                                  ? _c("el-tag", { attrs: { size: "mini" } }, [
                                      _vm._v("企业"),
                                    ])
                                  : scope.row.zoneType === 2
                                  ? _c(
                                      "el-tag",
                                      {
                                        attrs: {
                                          type: "success",
                                          size: "mini",
                                        },
                                      },
                                      [_vm._v("商家")]
                                    )
                                  : _c("span", [_vm._v("通用")]),
                              ]
                            },
                          },
                        ],
                        null,
                        false,
                        4099544668
                      ),
                    }),
                    _c("el-table-column", {
                      key: "hf-amount",
                      attrs: {
                        prop: "amount",
                        label: "变动开心果",
                        width: "120",
                      },
                    }),
                    _c("el-table-column", {
                      key: "hf-balanceAfter",
                      attrs: {
                        prop: "balanceAfter",
                        label: "变动后开心果",
                        width: "120",
                      },
                    }),
                    _c("el-table-column", {
                      key: "hf-linkId",
                      attrs: { prop: "linkId", label: "关联ID", width: "120" },
                    }),
                    _c("el-table-column", {
                      key: "hf-createTime",
                      attrs: {
                        prop: "createTime",
                        label: "创建时间",
                        "min-width": "150",
                      },
                    }),
                  ]
                : _vm._e(),
              _vm.activeTab === "commission"
                ? [
                    _c("el-table-column", {
                      key: "cm-uid",
                      attrs: { prop: "uid", label: "用户UID", width: "100" },
                    }),
                    _c("el-table-column", {
                      key: "cm-nickname",
                      attrs: {
                        prop: "nickname",
                        label: "用户昵称",
                        width: "120",
                      },
                    }),
                    _c("el-table-column", {
                      key: "cm-phone",
                      attrs: { prop: "phone", label: "手机号", width: "120" },
                    }),
                    _c("el-table-column", {
                      key: "cm-type",
                      attrs: { label: "类型", width: "120" },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "default",
                            fn: function (scope) {
                              return [
                                scope.row.type === 1
                                  ? _c("span", [_vm._v("直推奖释放转入")])
                                  : scope.row.type === 2
                                  ? _c("span", [_vm._v("复购扣减")])
                                  : scope.row.type === 3
                                  ? _c("span", [_vm._v("手动调整")])
                                  : _vm._e(),
                              ]
                            },
                          },
                        ],
                        null,
                        false,
                        3745015534
                      ),
                    }),
                    _c("el-table-column", {
                      key: "cm-zone",
                      attrs: { label: "专区", width: "90" },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "default",
                            fn: function (scope) {
                              return [
                                scope.row.zoneType === 1
                                  ? _c("el-tag", { attrs: { size: "mini" } }, [
                                      _vm._v("企业"),
                                    ])
                                  : scope.row.zoneType === 2
                                  ? _c(
                                      "el-tag",
                                      {
                                        attrs: {
                                          type: "success",
                                          size: "mini",
                                        },
                                      },
                                      [_vm._v("商家")]
                                    )
                                  : _c("span", [_vm._v("通用")]),
                              ]
                            },
                          },
                        ],
                        null,
                        false,
                        4099544668
                      ),
                    }),
                    _c("el-table-column", {
                      key: "cm-amount",
                      attrs: {
                        prop: "amount",
                        label: "变动佣金",
                        width: "120",
                      },
                    }),
                    _c("el-table-column", {
                      key: "cm-balanceAfter",
                      attrs: {
                        prop: "balanceAfter",
                        label: "变动后佣金",
                        width: "120",
                      },
                    }),
                    _c("el-table-column", {
                      key: "cm-remark",
                      attrs: {
                        prop: "remark",
                        label: "备注",
                        "min-width": "150",
                      },
                    }),
                    _c("el-table-column", {
                      key: "cm-createTime",
                      attrs: {
                        prop: "createTime",
                        label: "创建时间",
                        "min-width": "150",
                      },
                    }),
                  ]
                : _vm._e(),
              _vm.activeTab === "balance"
                ? [
                    _c("el-table-column", {
                      key: "bl-uid",
                      attrs: { prop: "uid", label: "用户UID", width: "100" },
                    }),
                    _c("el-table-column", {
                      key: "bl-nickname",
                      attrs: {
                        prop: "nickname",
                        label: "用户昵称",
                        width: "120",
                      },
                    }),
                    _c("el-table-column", {
                      key: "bl-phone",
                      attrs: { prop: "phone", label: "手机号", width: "120" },
                    }),
                    _c("el-table-column", {
                      key: "bl-type",
                      attrs: { label: "类型", width: "120" },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "default",
                            fn: function (scope) {
                              return [
                                scope.row.type === 1
                                  ? _c("span", [_vm._v("直推奖释放转入")])
                                  : scope.row.type === 2
                                  ? _c("span", [_vm._v("复购扣减")])
                                  : scope.row.type === 3
                                  ? _c("span", [_vm._v("提现扣减")])
                                  : scope.row.type === 4
                                  ? _c("span", [_vm._v("手动调整")])
                                  : scope.row.type === 5
                                  ? _c("span", [_vm._v("提现退回")])
                                  : _vm._e(),
                              ]
                            },
                          },
                        ],
                        null,
                        false,
                        3728358045
                      ),
                    }),
                    _c("el-table-column", {
                      key: "bl-zone",
                      attrs: { label: "专区", width: "90" },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "default",
                            fn: function (scope) {
                              return [
                                scope.row.zoneType === 1
                                  ? _c("el-tag", { attrs: { size: "mini" } }, [
                                      _vm._v("企业"),
                                    ])
                                  : scope.row.zoneType === 2
                                  ? _c(
                                      "el-tag",
                                      {
                                        attrs: {
                                          type: "success",
                                          size: "mini",
                                        },
                                      },
                                      [_vm._v("商家")]
                                    )
                                  : _c("span", [_vm._v("通用")]),
                              ]
                            },
                          },
                        ],
                        null,
                        false,
                        4099544668
                      ),
                    }),
                    _c("el-table-column", {
                      key: "bl-amount",
                      attrs: {
                        prop: "amount",
                        label: "变动余额",
                        width: "120",
                      },
                    }),
                    _c("el-table-column", {
                      key: "bl-balanceAfter",
                      attrs: {
                        prop: "balanceAfter",
                        label: "变动后余额",
                        width: "120",
                      },
                    }),
                    _c("el-table-column", {
                      key: "bl-remark",
                      attrs: {
                        prop: "remark",
                        label: "备注",
                        "min-width": "150",
                      },
                    }),
                    _c("el-table-column", {
                      key: "bl-createTime",
                      attrs: {
                        prop: "createTime",
                        label: "创建时间",
                        "min-width": "150",
                      },
                    }),
                  ]
                : _vm._e(),
              _vm.activeTab === "zoneConsume"
                ? [
                    _c("el-table-column", {
                      key: "zc-uid",
                      attrs: { prop: "uid", label: "用户UID", width: "100" },
                    }),
                    _c("el-table-column", {
                      key: "zc-nickname",
                      attrs: {
                        prop: "nickname",
                        label: "用户昵称",
                        width: "120",
                      },
                    }),
                    _c("el-table-column", {
                      key: "zc-phone",
                      attrs: { prop: "phone", label: "手机号", width: "120" },
                    }),
                    _c("el-table-column", {
                      key: "zc-zoneType",
                      attrs: { label: "专区类型", width: "120" },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "default",
                            fn: function (scope) {
                              return [
                                _c(
                                  "el-tag",
                                  {
                                    attrs: {
                                      type:
                                        scope.row.zoneType === 1
                                          ? ""
                                          : "success",
                                      size: "small",
                                    },
                                  },
                                  [
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          scope.row.zoneType === 1
                                            ? "企业活动专区"
                                            : "商家赋能专区"
                                        ) +
                                        " "
                                    ),
                                  ]
                                ),
                              ]
                            },
                          },
                        ],
                        null,
                        false,
                        1865546153
                      ),
                    }),
                    _c("el-table-column", {
                      key: "zc-consumeAmount",
                      attrs: {
                        prop: "consumeAmount",
                        label: "消费金额",
                        width: "100",
                      },
                    }),
                    _c("el-table-column", {
                      key: "zc-happyFruitGain",
                      attrs: {
                        prop: "happyFruitGain",
                        label: "开心果获得",
                        width: "110",
                      },
                    }),
                    _c("el-table-column", {
                      key: "zc-cumulativeBefore",
                      attrs: {
                        prop: "cumulativeBefore",
                        label: "消费前累计",
                        width: "110",
                      },
                    }),
                    _c("el-table-column", {
                      key: "zc-cumulativeAfter",
                      attrs: {
                        prop: "cumulativeAfter",
                        label: "消费后累计",
                        width: "110",
                      },
                    }),
                    _c("el-table-column", {
                      key: "zc-isLevelUp",
                      attrs: { label: "是否升级", width: "80" },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "default",
                            fn: function (scope) {
                              return [
                                scope.row.isLevelUp
                                  ? _c(
                                      "el-tag",
                                      {
                                        attrs: { type: "danger", size: "mini" },
                                      },
                                      [_vm._v("升级")]
                                    )
                                  : _c("span", [_vm._v("-")]),
                              ]
                            },
                          },
                        ],
                        null,
                        false,
                        2426420541
                      ),
                    }),
                    _c("el-table-column", {
                      key: "zc-orderNo",
                      attrs: {
                        prop: "orderNo",
                        label: "订单号",
                        "min-width": "150",
                      },
                    }),
                    _c("el-table-column", {
                      key: "zc-createTime",
                      attrs: {
                        prop: "createTime",
                        label: "创建时间",
                        "min-width": "150",
                      },
                    }),
                  ]
                : _vm._e(),
            ],
            2
          ),
          _c(
            "div",
            { staticClass: "block" },
            [
              _c("el-pagination", {
                attrs: {
                  "page-sizes": [20, 40, 60, 80],
                  "page-size": _vm.searchForm.limit,
                  "current-page": _vm.searchForm.page,
                  layout: "total, sizes, prev, pager, next, jumper",
                  total: _vm.tableData.total,
                  background: "",
                },
                on: {
                  "size-change": _vm.handleSizeChange,
                  "current-change": _vm.pageChange,
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }